import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import store from '@/store'
import routes from './routes'
import privateRoutes from './routes/private'
import { sync } from 'vuex-router-sync'
import { make } from './route-utils'
import { redirectAfterAuth, checkAuthInHome, loader } from './hooks'

Vue.use(Router)
Vue.use(Meta)

/*let routerPreferences = {
  routes: routes.map(beforeEnter)
}*/

let router = make(routes)
router = makeGuards(routes)
sync(store, router)

export default router

// Register before guard.
function makeGuards(router) {
  router.beforeEach(async (to, from, next) => {
   
    store.commit("auth/SET_TOKEN")
    const isAuth = localStorage.getItem('token')
  
    try {

      await loader(to, from, next)
      await checkAuthInHome(to, from, next)
      await redirectAfterAuth(to, from, next)

      //private routes
      if (privateRoutes.indexOf(to.name) !== -1) {
        if(isAuth) {
          return next()
        }
        else return next({name: 'auth', replace: true})
      }

      return next()
      
    } catch (err) {
      return next({name: 'auth', replace: true})
    }
  })

  // Register after hook.
  router.afterEach((to, from) => {
  })

  return router
}










// WEBPACK FOOTER //
// ./src/router/index.js